<template>
  <div id="app">
					<div class="text">
            <div class="container">
            <div class="row">
              <div class="col-md-3" style="text-align:left;">
 <b><label>Začiatok:</label></b>
<datetime type="datetime" v-model="dateFrom" @input="changeDate"></datetime>

</div>

<div class="col-md-3" style="text-align:left;">
  <b><label>Koniec</label></b>
<datetime type="datetime" v-model="dateTo"></datetime>
  </div>

<div class="col-md-3" style="text-align:left;">
  <b><label>Projekt</label></b>
<select class="form-control" id="sel1" v-model="project">
  <option value="all">Všetky</option>
    <option v-for="p in projects" :key="p.id" :value="p">{{p.name}}</option>
  </select>  </div>


<div class="col-md-2" style="text-align:left;">
  <b><label>Užívateľ</label></b>
<select class="form-control" id="sel1" v-model="user">
    <option v-for="(user, index) in users" :key="index" :value="user.email">{{user.firstname}} {{user.lastname}}</option>
  </select>  
  </div>
  

  <div class="col-md-1" style="text-align:left;margin-top:30px;">
						<button type="button" href="#" class="txt2 hov1 btn btn-primary" @click="set">
							Vvytvoriť
						</button>
          </div>

<div class="col-md-3" style="text-align:left;" v-if="project.type == 'drive'">
  <b><label>Štart KM</label></b>
  <input type="text" class="form-control" v-model="start_km">
  </div>


<div class="col-md-3" style="text-align:left;" v-if="project.type == 'drive'">
  <b><label>Koniec KM</label></b>
  <input type="text" class="form-control" v-model="end_km">
  </div>


</div>
<hr>
<div class="container">
  <h2>Výsledky</h2>            
  <table class="table table-striped" style="text-align:left">
    <thead style="text-align:left">
      <tr style="text-align:left">
        <th style="text-align:left">Začiatok</th>
        <th>Koniec</th>
        <th>Hodiny spolu</th>
        <th>Najazdené KM</th>

      </tr>
    </thead>
    <tbody>
      <tr v-for="task in this.result" :key="task.id">
        <td>{{task.data().begin.toDate() | moment("DD/MM/YYYY H:mm:ss")}}</td>
        <td>{{task.data().end.toDate() | moment("DD/MM/YYYY H:mm:ss")}}</td>
        <td>{{task.totalHours}}</td>
        <td>{{task.data().end_km - task.data().start_km}}</td>
      </tr>
    </tbody>
  </table>
<hr>
<p><b>Spolu odpracované:</b> {{totalHours}} hodín</p>
<p><b>Spolu najazdených:</b> {{totalKm}} kilometrov</p>
</div>


</div>
					</div>
  </div>
</template>

<script>
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../fonts/Linearicons-Free-v1.0.0/icon-font.min.css'
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../vendor/jquery/jquery-3.2.1.min.js'
import firebase from 'firebase'
import Datepicker from 'vuejs-datepicker';
import navbar from './components/Navbar.vue'
import Vue from 'vue'

export default {
  components : {
    Datepicker
  },
  name: 'Tracker',
  data() {
    return {
      project : "",
      type : "",
      projects : [],
      start_km : 0,
      end_km : 0,
      dateFrom : '',
      dateTo : '',
      user : '',
      users : [],
      result : [],
      totalSeconds : 0,
      totalHours : "",
      totalKm : 0
    }
  },
  methods : {
      async getUsers()
    {
      console.log("getUsers");
            await firebase.firestore().collection('user').get().then(snap => {
        if(!snap.empty)
        {
          console.log("snap not empty");
          this.users = snap.docs.map(x => x.data());
        }
        });
    },  
    changeDate()
    {
      console.log("changed!");
      console.log(new Date(this.dateFrom));
    },
        secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hodina, " : " hodín, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minúta, " : " minút, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " sekunda" : " sekúnd") : "";
    return hDisplay + mDisplay + sDisplay; 
},
    async getProjects()
    {
            await firebase.firestore().collection('project').get().then(snap => {
        if(!snap.empty)
        {
          console.log("snap not empty");
          this.projects = snap.docs.map(x => x.data());
        }
        });
    },
    dateChange()
    {
      console.log("wat");
      console.log(this.dateFrom);
    },
    async set()
    {
      var toast = this.$toast;
      console.log("setting " + this.project.name + " with type of " + this.project.type + "with km of " + this.start_km + " and end km " + this.end_km);

      firebase.firestore().collection('timer').doc().set({
        project : this.project.name,
          begin: new Date(this.dateFrom),
          end : new Date(this.dateTo),
          email : this.user,
          type : this.project.type,
          start_km : this.start_km,
          end_km : this.end_km
      }).then(res => {
        console.log("should be ok");
        toast.success('Záznam úspešne vytvorený.', { position:'top' });
      }).catch(e => {
        console.log("error:");
        console.log(e);
      });
    }
  },  
  created()
  {
    this.getUsers();
    this.getProjects();
    
    console.log("tracker!");

    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
